import React from 'react';
import Sidebar from './Sidebar';

export default function TermsOfUsePage() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white md:px-6 lg:px-10 max-w-7xl">
      <Sidebar />
      <div className="flex-1 p-4 lg:p-8">
        <h1 className="text-3xl md:text-5xl leading-14 font-axi-bold my-5">
          Kasutustingimused
        </h1>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          1. Üldsätted
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          1.1 Käesolevad Rademari e-poe müügitingimused (edaspidi: tingimused)
          kehtivad internetiaadressil{' '}
          <a href="https://www.rademar.ee/" className="text-rgreen underline">
            www.rademar.ee
          </a>{' '}
          asuval ostukeskkonnast (edaspidi: e-pood) ostmisel.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          1.2 E-pood müüb Rademar OÜ-le kuuluvates kauplustes (Rademar ja
          Rademar Outlet).
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          1.3 Tingimused kehtivad õigussuhetele, mis tekivad kliendi (edaspidi:
          klient) ja e-poe omaniku Rademar OÜ (edaspidi müüja) vahel seoses
          e-poest toodete ostmisega.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          1.4 Käesolevatele tingimustele lisaks reguleerivad e-poes toodete
          ostmisel tekkivaid õigussuhteid Eesti Vabariigis kehtivad õigusaktid.
        </p>
        <p className="text-base leading-6 mx-0 my-2">1.5 Müüja andmed:</p>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">Rademar OÜ;</li>
          <li className="text-base leading-6 mx-0 my-2">
            Värvi 14, Tallinn 10621;
          </li>
          <li className="text-base leading-6 mx-0 my-2">Reg. nr 10235879;</li>
          <li className="text-base leading-6 mx-0 my-2">
            Telefon
            <a
              className="ml-2 underline font-axi-book text-rgreen"
              href="tel:+372 61 541 30"
            >
              +372 61 541 30;
            </a>
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            E-post
            <a
              className="ml-2 underline font-axi-book text-rgreen"
              href="mailto:info@rademar.ee"
            >
              info@rademar.ee.
            </a>
          </li>
        </ul>
        <p className="text-base leading-6 mx-0 my-2">
          1.6 Müüjal on õigus ühepoolselt muuta e-poe kasutustingimusi ja hindu.
          Müüja annab muudatustest teada{' '}
          <a href="https://www.rademar.ee/" className="text-rgreen underline">
            www.rademar.ee.
          </a>{' '}
          Kui klient esitas tellimuse enne muudatuste jõustumist, rakendatakse
          tehingule tehingu toimumise hetkel kehtivaid tingimusi ja hindu.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          2. Klienditugi
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          2.1 Klienditoe telefoninumber on{' '}
          <a className="underline text-rgreen" href="tel:+372 61 541 38">
            +372 61 541 38
          </a>{' '}
          (avatud tööpäeviti kl 9-16.30).
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          2.2 E-posti aadress:{' '}
          <a className="underline text-rgreen" href="mailto:epood@rademar.ee">
            epood@rademar.ee.
          </a>
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          2.3 Riiklikel pühadel on klienditugi suletud.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          3. Hinnad
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          3.1 Kõik e-poe toodete hinnad sisaldavad 24%-list käibemaksu ning on
          esitatud eurodes.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          3.2 E-poe toodete hinnad, allahindlused, pakkumised ja kampaaniad
          võivad erineda müüja jaekaupluste hindadest, allahindlustest,
          pakkumistest ja kampaaniatest.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          3.3 Transpordi hinnad on välja toodud punktis 8.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          4. Tooted
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          4.1 E-poe tooted on reeglina olemas laos või müüja jaekauplustes.
          Toodete saadavust ei tagata, kuna laoseis võib tehniliste probleemide
          tõttu olla ekslik.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          4.2 Kui kliendi tellitud toode müüjal puudub, teavitatakse klienti
          sellest esimesel võimalusel.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          4.3 Tasutud tellimuse kogu ostusumma tagastatakse esimesel võimalusel,
          kuid mitte hiljem kui 14 kalendripäeva jooksul.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          5. E-poes registreerumine
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          5.1 Registreerunud ja sisselogitud püsikliendile rakendub 5%-line
          soodustus täishinnaga toodetelt.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          5.2 Transporditasule püsikliendi soodustus ei rakendu.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          6. Tellimuse esitamine
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          6.1 Tellimusi saab esitada e-poes registreeritud kasutajana sisse
          logides või anonüümse kliendina.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          6.2 Klient valib välja e-poest soovitud tooted ning lisab ostukorvi.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          6.3 Klient kontrollib ostukorvi õigsust, seejärel kinnitab ostukorvi.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          6.4 Klient sisestab nõutud andmed, valib sobiva kohaletoimetamise
          viisi ja nõustub kasutustingimustega.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          6.5 Klient tasub tellimuse eest maksekeskonnas.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          6.6 Pärast tellimuse eest tasumist tuleb kliendil vajutada "Tagasi
          kaupmehe juurde".
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          6.7 Tellimuse ja makse kättesaamise kohta saadab müüja kliendile
          e-kirjaga kinnituse ja arve.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          6.8 Müüja ja kliendi vaheline müügileping loetakse sõlmituks hetkest,
          mil kaup on kliendile saatmiseks teele pandud.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          7. Makseviisid
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          7.1 Tellimuse eest saab turvaliselt tasuda Eesti pangalinkide
          (Swedbank, SEB, Luminor, LHV, Coop, Citadele, Revolut, N26) ja Inbank
          AS (maksa järgmisel kuul, maksa kolmes või kuues võrdses osas) abil.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          7.2 Makse toimub väljaspool e-poodi teenusepakkuja Montonio Finance OÜ
          või Inbank AS turvalises maksekeskonnas.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          7.3 Makseteenuse pakkuja on kohustatud tagama, et kliendi isikuandmed
          ja pangaandmed on kaitstud volitamata juurdepääsu eest.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          7.4 Müüjal puudub ligipääs kliendi pangaandmetele ja krediitkaardi
          andmetele.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          7.5 Maksmine toimub eurodes.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          8. Kauba kättesaamine
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          8.1 Kliendil on võimalik tellimuse kohaletoimetamiseks valida DPD
          pakiautomaat ja Omniva pakiautomaat või kullerteenus.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.2 Tellimuse kohaletoimetamine Omniva pakiautomaati.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.2.1 Tellimuse hinnale lisandub kohaletoimetamise tasu Omniva 1.90 €
          ja DPD 1.60 €.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.2.2 Tellimusele alates 69 € kohaletoimetamise tasu ei lisandu.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.2.3 Pärast müügilepingu jõustumist saabub tellimus kliendi poolt
          valitud pakiautomaati.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.2.4 Toote kohalejõudmisest pakiautomaati teavitatakse klienti
          SMS-teatega, mis sisaldab pakiautomaadi ukse avamiseks unikaalset
          uksekoodi, pakiautomaadi asukohta, hoiutähtaja lõppu ning
          tagastuskoodi.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.2.5 Müüja ei vastuta kliendile tekkinud kahju eest, kui müüjast
          mittetulenevatel põhjustel on pakiautomaadi unikaalne kood jõudnud
          kolmandate isikute valdusesse ning selle alusel on kaup kätte saadud.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.2.6 Tellimust hoitakse pakiautomaadis 7 kalendripäeva. Pärast
          nimetatud tähtaja saabumise lõppu saadetakse toode tagasi e-poodi.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.2.7 Juhul kui klient ei lähe tellimuse järgi eelmainitud tähtaja
          jooksul, on klient kohustatud hüvitama transpordiga seotud kulud.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.3 Tellimuse kohaletoimetamine Omniva kulleriga.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.3.1 Tellimuse hinnale lisandub Omniva kohaletoimetamise tasu 3.90 €.
          Ratastele, suuskadele ja kelkudele lisandub kohaletoimetamise tasu 15
          €.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.3.2 Pärast müügilepingu jõustumist saabub tellimus kliendi poolt
          valitud aadressile. Kauba täpse üleandmise aja lepib kuller kliendiga
          eelnevalt telefoni teel kokku.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.3.3 Klient peab tagama kokkulepitud ajal ja aadressil tellimuse
          vastuvõtmise.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.3.4 Juhul, kui klient on vormistanud tellimuse nädalavahetusel
          (ajavahemikul reedel pärast kella 14:00 kuni esmaspäeval kella 9:00ni)
          või riigipühal, hakkab 7 tööpäeva tähtaeg kehtima nädalavahetusele või
          riigipühale järgneval esimesel tööpäeval kell 9:00.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.3.5 Klient on kohustatud enne tellimuse vormistamist kontrollima
          esitatavate kontaktandmete õigsust, vältimaks viivitusi ja
          arusaamatusi. Müüja ei vastuta viivituse või arusaamatuse eest, juhul
          kui see on tingitud kliendi poolt tellimuse vormistamisel esitatud
          andmete ebatäpsuse tõttu.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          8.3.6 Juhul, kui klient avastab kauba kättesaamisel, et talle on
          saadetud vale või defektne kaup või kaup ei jõua kliendini heas
          seisukorras ja kinnises pakendis, tuleb sellest koheselt e-poodi
          teavitada, saates vastavasisulise kirja e-posti aadressile{' '}
          <a className="underline text-rgreen" href="mailto:epood@rademar.ee">
            epood@rademar.ee.
          </a>
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          9. Tellimuse tagastamine ja ümbervahetamine
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          9.1 Kliendil on õigus tellimusest 14 kalendripäeva jooksul põhjust
          avaldamata taganeda ning tellitud toode või tooted ümber vahetada või
          tagastada.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.2 Klient kannab kauba tagastamisega seotud otsesed kulud (1.99 €),
          tasu arvestatakse automaatselt maha tagastatavast summast. Defektse
          toote tagastamise puhul tasub kauba tagastamisega seotud kulud müüja.
          Jalgrataste tagastamistasu on 15 €.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.3 14-päevane tagastusõigus kehtib ainult e-poest ostetud kaubale
          ning ei laiene kaupluses sooritatud ostudele.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.4 Toodete tagastamiseks ja/või vahetamiseks tuleb müüjale esitada
          taganemisavaldus 14 kalendripäeva jooksul alates kauba kättesaamise
          hetkest. Täidetud taganemisavaldus tuleb saata koos tagastatud tootega
          müüjale.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.5 Klient on kohustatud avama toote pakendi ettevaatlikult, seda
          kahjustamata. Kui pakendit ei ole võimalik avada seda rikkumata, ei
          ole originaalpakendis toote tagastamine nõutav.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.6 Kliendil on õigus tootega tutvuda viisil, nagu see on lubatud
          tavapärases kaupluses ning klient vastutab tootega tutvumisel toote
          väärtuse vähenemise eest, kui ta on toodet kasutanud eeltoodust muul
          viisil.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.7 Kaupadele, mida oma olemuse tõttu ei saa tagastada (aluspesu,
          ujumis- ja päevitusriided, sokid), ei kehti 14-päevane taganemisõigus
          juhul, kui toote pakend on avatud.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.8 Juhul, kui kohaletoimetamise viisiks oli valitud Omniva
          pakiautomaat saab tellimuse ümber vahetada või tagastada Omniva
          pakiautomaadi vahendusel, kasutades selleks esialgses SMS-is
          sisalduvat tagastuskoodi.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.9 Juhul, kui kohaletoimetamise viisiks oli valitud Omniva kuller,
          saab tellimuse ümber vahetada või tagastada, viies selle vabalt
          valitud postkontorisse. Toote ümbervahetamiseks ja tagastamiseks on
          nõutav toote ostupakendil olev triipkood. Tagastus jõuab e-poodi 3
          tööpäeva jooksul.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.10 E-poest ostetud toodet on võimalik ümber vahetada ainult sama
          toote teise suuruse vastu. Kaupluses on ümbervahetamine võimalik
          juhul, kui soovitud suurus on vahetuse hetkel vastavas kaupluses
          saadaval. E-poe kaudu ümbervahetamisel saadetakse soovitud suuruses
          toode pärast ümbervahetatava toote kättesaamist ja ümbervahetuse
          vormistamist. Ümbervahetusega seotud transpordikulud kannab müüja.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          9.11 Juhul, kui klient on tehingust taganenud, tagastab müüja
          kliendile ostusumma, millelt on maha arvatud tagastamise tasu 1.99 €,
          esimesel võimalusel, kuid mitte hiljem kui 14 kalendripäeva jooksul
          tagastuse jõudmisest müüjale. Tagasimakse tehakse samale
          arvelduskontole, millelt ostu eest tasuti. Jalgrataste tagastamistasu
          on 15 €.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          10. Kliendi isikuandmete töötlemine
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          10.1 Klient annab e-poes andmeid sisestades ning vastava kinnitusega
          õiguse koguda ja töödelda kliendi isikuandmeid (Ees- ja perekonnanimi,
          telefoni number, paki kättetoimetamise ja/või kodune aadress, e-posti
          aadress).
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          10.2 Müüja ei edasta kliendi isikuandmeid kolmandatele isikutele,
          väljaarvatud makseteenust osutavale Montonio Finance OÜ-le ja AS
          Inbank-ile ja tarneteenust pakkuvale DPD Eesti AS-ile ja AS Eesti
          Post-ile.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          10.3 Müüja säilitab kliendi kohta ostude sooritamise käigus kliendi
          poolt sisestatud kontaktandmed ja info sooritatud ostude kohta. Seda
          infot käsitletakse konfidentsiaalsena ja töödeldakse kooskõlas
          isikuandmete kaitse seadusega.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          10.4 Müüja võib kasutada kliendi isikuandmeid otsepostituseks üksnes
          juhul, kui klient on selle jaoks andnud oma nõusoleku.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          10.5 Andmeside kliendi ja pankade ning kaardimaksete vahel on
          krüpteeritud, mis tagab kliendi isikuandmete ja pangaandmete
          turvalisuse. Makse teostamine toimub väljas pool e-poe keskkonda ning
          e-poel puudub ligipääs kliendi pangaandmetele ja krediitkaardi
          andmetele.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          11. Pretensioonide esitamine ja vastutus
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          11.1 Müüja vastutab ostetud tootel ilmneva mittevastavuse eest 2 aasta
          jooksul alates toote kliendile üleandmisest. Tarbijale toote müümise
          korral eeldatakse, et 12 kuu jooksul kauba kliendile üleandmise
          päevast ilmnenud lepingutingimustele mittevastavus oli olemas asja
          üleandmise ajal, kui selline eeldus ei ole vastuolus asja või puuduse
          olemusega. Klient kohustub müüjat teavitama kauba mittevastavusest
          hiljemalt 2 kuu jooksul selle avastamisest ehk esitama pretensiooni.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          11.2 Kliendil on soovitatav esitada pretensioon{' '}
          <a className="underline text-rgreen" href="mailto:epood@rademar.ee">
            epood@rademar.ee.
          </a>{' '}
          Pretensiooni märkida kontaktandmed, probleemi täpne kirjeldus,
          pretensiooni esitamise kuupäev ning lisada ostu tõendav dokument.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          11.3 Müüja ei vastuta tellitud toote mittesihipärasest kasutamisest
          tekkinud kahjude eest.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          11.4 Müüja ei vastuta tellimuse täitmisel kliendi poolt esitatud
          ebakorrektsetest andmetest tekkiva kahju või mis tahes muude
          tagajärgede eest, sealhulgas kohaletoimetamise viivituse eest, kui see
          on tingitud asjaoludest, mida müüjal ei olnud võimalik mõjutada.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          11.5 Müüja ja kliendi vahel tekkivad vaidlused lahendavad pooled
          läbirääkimiste teel. Kokkuleppe mittesaavutamisel on kliendil õigus
          pöörduda Tarbijakaitseametisse (Endla 10A, 10112 Tallinn,{' '}
          <a
            href="https://www.tarbijakaitseamet.ee"
            className="text-rgreen underline"
          >
            www.tarbijakaitseamet.ee
          </a>
          ) ja tarbijavaidluste komisjoni (Endla 10A Tallinn 10112,{' '}
          <a href="https://www.komisjon.ee" className="text-rgreen underline">
            www.komisjon.ee
          </a>
          ) vaidluse kohtuväliseks lahendamiseks või Harju Maakohtusse. Lisaks
          on kõikidele klientidele avatud e-kauplejatega tekkinud kaebuste
          lahendamiseks Euroopa Liidu elektrooniline keskkond ODR-platvorm
          (Online Dispute Resolution ehk veebipõhine vaidluste lahendamine)
          aadressil{' '}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            className="text-rgreen underline"
          >
            ec.europa.eu.
          </a>
        </p>
      </div>
    </div>
  );
}
